<template>
  <p
    v-for="addressLine in formattedAddress"
    :key="addressLine"
    class="text-static-default-low"
  >
    {{ addressLine }}
  </p>
  <p class="text-static-default-low">{{ address.phone }}</p>
</template>

<script setup lang="ts">
import { useFormatAddress } from '@backmarket/nuxt-module-address/useFormatAddress'

import type { Address as CareFolderAddress } from '~/api/care-folders/types/care-folder'
import type { Address } from '~/api/care-folders/types/product-return'

const props = defineProps<{
  address: CareFolderAddress | Address
}>()

const formattedAddress = useFormatAddress(
  {
    city: props.address.city,
    country: props.address.country,
    countryDialInCode: props.address.countryDialInCode,
    firstName: props.address.firstName || '',
    firstNamePronunciation: props.address.firstNamePronunciation || undefined,
    lastName: props.address.lastName || '',
    lastNamePronunciation: props.address.lastNamePronunciation || undefined,
    phone: props.address.phone,
    postalCode: props.address.postalCode || '',
    stateOrProvince: props.address.stateOrProvince || '',
    street: props.address.street,
    street2: props.address.street2 || undefined,
  },
  { includeName: true },
)
</script>
